<div class="fx fx--col fx-fill">
  <header class="header text-center">
    <button mat-icon-button class="close-button" (click)="onEmployeeAssignClose()">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
    <p class="text--gray text-20-500">Which employee(s) to assign?</p>
  </header>

  <div class="bg-gray fx-grow">
    <div class="container-details">
      <mat-card>
        <mat-card-content>
          <div class="fx fx--col fx__gap--8 py-8 border">
            <div class="fx fx__just--space-between fx__align--center">
              <span class="text--light-gray text-12-500">PHASE {{ phase?.phaseNameId }}</span>
              <span class="text--light-gray text-12-500 nowrap">
                {{ phase?.startDate }} - {{ phase?.endDate }}
              </span>
            </div>
            <div class="fx fx__just--space-between fx__align--center">
              <span class="text--gray text-20-500 pt-4">
                {{ phase?.phaseName }}
              </span>
              <span class="text--gray text-20-500 pt-4">
                {{ phase?.assigned }}/{{ phase?.required }}
              </span>
            </div>
            <div class="gd gd__row-gap--8 professions-grid">
              <span
                *ngFor="let profession of phase?.professionCounters"
                class="fx profession-item text--light-gray text-14-500"
              >
                <ng-container *ngIf="profession.professionName !== 'Other'">
                  <div
                    cdkOverlayOrigin
                    #trigger2="cdkOverlayOrigin"
                    (mouseenter)="onProfessionMouseEnter(profession.professionId)"
                    (mouseleave)="onProfessionMouseLeave()">
                    {{ profession.professionName }} {{ profession.assigned }}/{{ profession.required }}
                  </div>
                  <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="trigger2"
                    [cdkConnectedOverlayOpen]="hoveredProfessionId === profession.professionId"
                    [cdkConnectedOverlayPositions]="[
                      { originX: 'end', originY: 'center', overlayX: 'start', overlayY: 'center' }
                    ]"
                    [cdkConnectedOverlayOffsetX]="10"
                  >
                    <div class="popover-wrapper">
                      <app-tooltip
                        [skills]="findRequiredSkillsOrCertificatesByProfessionId(profession.professionId, 'skills')"
                        [certificates]="findRequiredSkillsOrCertificatesByProfessionId(profession.professionId, 'certificates')">
                      </app-tooltip>
                    </div>
                  </ng-template>
                </ng-container>
              </span>
            </div>
          </div>
          <form name="filter" [formGroup]="employeeFilterForm" class="py-16">
            <div class="fx fx--col fx__gap--16">
              <div class="fx fx--row fx__gap--16">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-icon matPrefix svgIcon="magnify"></mat-icon>
                  <mat-label>Search for an employee</mat-label>
                  <input matInput #nameSearch type="text" formControlName="search">
                  <button
                    matSuffix
                    *ngIf="nameSearch.value.length"
                    mat-icon-button
                    type="button"
                    class="close-btn"
                    (click)="employeeFilterForm.get('search').setValue('')"
                  >
                    <mat-icon svgIcon="close"></mat-icon>
                  </button>
                </mat-form-field>
                <mat-form-field appearance="fill">
                  <mat-label>Professions</mat-label>
                  <mat-select formControlName="professionId">
                    <mat-option value=""></mat-option>
                    <mat-option *ngFor="let profession of filteredProfessions; trackBy: professionIdTracker" [value]="profession.id">
                      {{ profession.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="fx fx--row fx__gap--16">

                <mat-form-field appearance="fill">
                  <mat-label>Status</mat-label>
                  <mat-select formControlName="statuses" multiple>

                    <mat-option *ngFor="let status of statuses$ | async" [value]="status.value">
                      {{ status.value }}
                    </mat-option>

                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>Visas</mat-label>
                  <mat-select formControlName="visaTypeIds" multiple>
                    <mat-option *ngFor="let visa of visaTypes$ | async" [value]="visa.id">
                      {{ visa.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>Skills</mat-label>
                  <mat-select formControlName="skillIds" multiple>
                    <mat-optgroup *ngFor="let skillGroup of skillGroups$ | async" [label]="skillGroup.name">
                      <mat-option *ngFor="let skill of skillGroup.skills" [value]="skill.id">
                        {{ skill.name }}
                      </mat-option>
                    </mat-optgroup>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="fill">
                  <mat-label>Certificates</mat-label>
                  <mat-select formControlName="certificateIds" multiple>

                    <mat-option *ngFor="let certificate of certificates$ | async" [value]="certificate.id">
                      {{ certificate.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <mat-checkbox color="primary" formControlName="availableOnly">
              show only available employees
            </mat-checkbox>
          </form>
          <p *ngIf="candidatesLoading" role="status">Loading employees…</p>
          <p *ngIf="candidatesError" role="alert">{{ candidatesError }}</p>
          <button mat-button type="button" (click)="refreshCandidates()">Check again</button>
          <div class="dialog__radio">
            <form [formGroup]="employeeForm">
              <mat-selection-list
                formControlName="employeeId"
                aria-label="Employees to assign"
                multiple="true"
                (selectionChange)="onEmployeeSelectionChange($event)"
              >
                <mat-list-option
                  #employeeOption
                  togglePosition="before"
                  color="primary"
                  *ngFor="let employee of employees$ | async; trackBy: employeeIdTracker"
                  [value]="employee.id"
                  class="assignment-option"
                  [disabled]="employee.assignmentAvailability.state !== 'available'"
                  [attr.aria-description]="employee.assignmentAvailability.message || null"
                  (mouseenter)="!employee.isAvailable || employee.assignmentAvailability.message ? openConflictsPopover(employee.id) : null"
                  (mouseleave)="allowConflictsPopover(employee.id)"
                  (focus)="!employee.isAvailable || employee.assignmentAvailability.message ? openConflictsPopover(employee.id) : null"
                  (blur)="allowConflictsPopover(employee.id)"
                  (keydown.escape)="isConflictsPopoverOpen && $event.stopPropagation(); closeConflictsPopover()"
                >
                  <div
                    matListItemIcon
                    cdkOverlayOrigin
                    #trigger="cdkOverlayOrigin"
                    class="icon-container"
                  >
                    <mat-icon
                      color="warn"
                      [class.assignment-warning]="employee.assignmentAvailability.state === 'available'"
                      *ngIf="!employee.isAvailable || (employee.assignmentAvailability.message && employee.assignmentAvailability.state !== 'checking')"
                      svgIcon="alert"
                    ></mat-icon>
                  </div>
                  <ng-template
                    cdkConnectedOverlay
                    [cdkConnectedOverlayOrigin]="trigger"
                    [cdkConnectedOverlayOpen]="hoveredEmployeeId === employee.id && isConflictsPopoverOpen"
                    [cdkConnectedOverlayPositions]="[
                      {
                        originX: 'end',
                        originY: 'center',
                        overlayX: 'start',
                        overlayY: 'center'
                      },
                      { originX: 'start', originY: 'center', overlayX: 'end', overlayY: 'center' },
                      { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' }
                    ]"
                    [cdkConnectedOverlayOffsetX]="10"
                    [cdkConnectedOverlayPush]="true"
                    [cdkConnectedOverlayViewportMargin]="8"
                    (overlayOutsideClick)="closeConflictsPopover()"
                  >
                    <div class="popover-wrapper" role="dialog"
                      [attr.aria-label]="'Assignment warning for ' + employee.firstName + ' ' + employee.lastName"
                      (keydown.escape)="$event.stopPropagation(); dismissConflictsPopover(); employeeOption.focus()">
                      <app-recommend-employee-conflicts
                        [conflicts]="conflicts$ | async"
                        [warningStatus]="currentPopoverWarningStatus"
                        [otherWarnings]="employee.assignmentAvailability.message ? [employee.assignmentAvailability.message] : []"
                        [severity]="employee.assignmentAvailability.state === 'blocked' || employee.assignmentAvailability.state === 'unavailable' ? 'error' : 'warning'"
                        (dismissed)="dismissConflictsPopover(); employeeOption.focus()"
                      >
                      </app-recommend-employee-conflicts>
                    </div>
                  </ng-template>
                  <span matListItemTitle>
                    {{ employee.naturalId }}. {{ employee.firstName }} {{ employee.lastName }}
                    <ng-container *ngIf="employee.professionName">
                      | {{ employee.professionName }}
                    </ng-container>
                  </span>
                  <span matListItemLine class="text-14-500 assignment-message" *ngIf="employee.warningStatus || !employee.isAvailable || employee.assignmentAvailability.message">
                    <span
                      *ngIf="employee.warningStatus"
                      [ngStyle]="{ color: !employee.isAvailable ? '#FFA425' : 'inherit' }"
                    >
                      Employee has a {{ employee.warningStatus }} status
                    </span>
                    <span
                      *ngIf="!employee.isAvailable && !employee.warningStatus"
                      [ngStyle]="{ color: '#FFA425' }"
                    >
                      Conflicts projects dates
                    </span>
                    <ng-container *ngIf="employee.assignmentAvailability.message">
                      <span *ngIf="employee.warningStatus || !employee.isAvailable"> · </span>
                      <span [class.assignment-blocked]="employee.assignmentAvailability.state === 'blocked' || employee.assignmentAvailability.state === 'unavailable'"
                        [class.assignment-warning]="employee.assignmentAvailability.state === 'available'">
                        {{ employee.assignmentAvailability.label || (employee.assignmentAvailability.state === 'checking' ? 'Checking availability…' : 'Availability could not be checked') }}
                      </span>
                    </ng-container>
                  </span>
                </mat-list-option>
              </mat-selection-list>

              <p class="text-center text--light-gray" *ngIf="!candidatesLoading && !candidatesError && !(employees$ | async)?.length">
                No employees meeting the given criteria
              </p>
            </form>
          </div>
          <div class="fx fx__just--end fx__align--center">
            <button mat-button type="button" *ngIf="isPreviousStep" (click)="goBackToPreviousStep()">
              Previous
            </button>
            <button
              mat-flat-button
              color="primary"
              [disabled]="employeeForm.invalid || !canAssign"
              (click)="onEmployeeSelect()"
            >
              Assign
            </button>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
